/**
 * Product Catalog status chip: colored dot + soft tinted background, no border.
 * Single source of truth for catalog status colors (table cells, sidebar header, mobile cards).
 */
export const CATALOG_STATUS_CHIP_STYLES = {
    ACTIVE: { dot: "bg-emerald-500", bg: "bg-emerald-50", text: "text-emerald-800" },
    SUNSET: { dot: "bg-orange-400", bg: "bg-orange-50", text: "text-orange-700" },
    PLANNED: { dot: "bg-blue-400", bg: "bg-blue-50", text: "text-blue-700" },
    IN_ACTIVE: { dot: "bg-gray-400", bg: "bg-gray-100", text: "text-gray-500" },
};

const CATALOG_STATUS_LABELS = {
    ACTIVE: "Active",
    SUNSET: "Sunset",
    PLANNED: "Planned",
    IN_ACTIVE: "Inactive",
};

/** Accepts either a status code (ACTIVE, IN_ACTIVE) or a display label ("Active", "Inactive"). */
export function normalizeCatalogStatus(value) {
    const normalized = String(value ?? "").trim().toLowerCase().replace(/[\s_-]/g, "");
    if (normalized === "inactive") return "IN_ACTIVE";
    if (normalized === "sunset") return "SUNSET";
    if (normalized === "planned") return "PLANNED";
    if (normalized === "active") return "ACTIVE";
    return null;
}

export function catalogStatusLabel(value) {
    const code = normalizeCatalogStatus(value);
    return code ? CATALOG_STATUS_LABELS[code] : "—";
}

export function CatalogStatusChip({ status, label, className = "" }) {
    const styles = CATALOG_STATUS_CHIP_STYLES[status] ?? CATALOG_STATUS_CHIP_STYLES.IN_ACTIVE;
    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-sm px-2 py-0.5 text-[11px] font-medium leading-none tracking-wide ${styles.bg} ${styles.text} ${className}`.trim()}
        >
            <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${styles.dot}`} aria-hidden />
            {label}
        </span>
    );
}

export default CatalogStatusChip;
